import { render, staticRenderFns } from "./OfferReporterGraphql.vue?vue&type=template&id=36aa2cf8&"
import script from "./OfferReporterGraphql.vue?vue&type=script&lang=ts&"
export * from "./OfferReporterGraphql.vue?vue&type=script&lang=ts&"
import style0 from "./OfferReporterGraphql.vue?vue&type=style&index=0&id=36aa2cf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports